import React from "react";

/**
 * Pill button — Beyonds-inspired light theme.
 * variants:
 *  - primary    : fond bleu #2B7BE4, texte blanc
 *  - ghostNight : pas de fond, texte #1A2F6E (style Beyonds "Prendre RDV")
 *  - outlineNight: bordure #1A2F6E, texte #1A2F6E
 *  - whitePill  : fond blanc, texte #1A2F6E (sur fonds sombres)
 *  - outlineLight: bordure blanche translucide, texte blanc (sur fonds sombres)
 */
export default function PillButton({
    as: Component = "button",
    variant = "primary",
    size = "md",
    className = "",
    children,
    ...rest
}) {
    const base =
        "inline-flex items-center justify-center gap-2 rounded-full font-semibold tracking-tight transition-all duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[#2B7BE4] focus-visible:ring-offset-[#F7F7F5] will-change-transform select-none";
    const sizes = {
        sm: "px-4 py-2 text-sm",
        md: "px-6 py-3 text-base",
        lg: "px-7 py-3.5 text-base md:text-[17px]",
    };
    const variants = {
        primary:
            "bg-[#2B7BE4] text-white hover:bg-[#1A2F6E] hover:-translate-y-0.5 hover:shadow-[0_18px_40px_-12px_rgba(43,123,228,0.55)]",
        ghostNight:
            "text-[#1A2F6E] hover:text-[#2B7BE4]",
        outlineNight:
            "border border-[#1A2F6E]/20 text-[#1A2F6E] hover:bg-[#1A2F6E] hover:text-white hover:border-[#1A2F6E]",
        whitePill:
            "bg-white text-[#1A2F6E] hover:bg-[#EEF2FB] hover:-translate-y-0.5 shadow-[0_8px_24px_-8px_rgba(0,0,0,0.25)]",
        outlineLight:
            "border border-white/30 text-white hover:bg-white/10 hover:border-white/60 backdrop-blur-md",
        // legacy variants kept for back-compat
        outlineDark:
            "border border-[#1A2F6E]/15 text-[#1A2F6E] hover:bg-[#1A2F6E] hover:text-white",
        ghost:
            "text-[#1A1A2E]/80 hover:text-[#1A1A2E]",
    };
    return (
        <Component
            className={`${base} ${sizes[size]} ${variants[variant] || variants.primary} ${className}`}
            {...rest}
        >
            {children}
        </Component>
    );
}
